import React, {Component} from 'react';
import {connect} from 'react-redux';
import Validate from 'app/validation/validation';
import AnalyticsManager from '../../../../app/analytics';
import './index.scss';
import x_close from 'assets/icons/x-close-white-icon.svg';

import {executeWithCaptcha, getMediaPath} from 'app/functions';

//components
import AnimatedInput from 'components/forms/animated_input';
import {sendAppLinkSms} from "../../../../redux/actions";
import Recaptcha from "../../../../components/services/google/recaptcha";

class AppPopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            first_try: true,
            form: {
                phone: {
                    val: '',
                    valid: false,
                    rules: ['not_empty', 'cell'],
                    errMsg: ''
                }
            },
        };
        this.animateOut = this.animateOut.bind(this);
        this.animateIn = this.animateIn.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.appDownStatus && this.props.appDownStatus !== prevProps.appDownStatus) {
            AnalyticsManager.logRequestAppDownload();
        }
    }

    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }

    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if (callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    handleInput = (ev) => {
        const {name, value} = ev.target

        let validate = Validate(value, this.state.form[name].rules);
        let is_valid = validate.valid;
        let msg = validate.msg;
        let new_state = {...this.state.form,[name]: {...this.state.form[name], val:value, valid:is_valid, errMsg:msg}};

        this.setState({form:new_state});
    }

    handleSubmit(e) {
        e.preventDefault();
        let form_valid = true;
        let new_state = this.state.form;

        for (let field in this.state.form) {
            let validate = Validate(this.state.form[field].val, this.state.form[field].rules);
            let is_valid = validate.valid;
            let msg = validate.msg;

            new_state[field].valid = is_valid;
            new_state[field].errMsg = msg;

            if (is_valid === false) {
                form_valid = false;
            }
        }
        this.setState({form: new_state, first_try: false});

        if (form_valid) {
            let payload = {}
            executeWithCaptcha((token) => {
                payload['phone'] = this.state.form.phone.val;
                payload['g-recaptcha-response'] = token;
                this.props.sendAppLinkSms(payload);
            });
        }
    }

    render() {
        const data = this.props.PopTrans.application;
        const appStatus = this.props.appDownStatus;
        const showErrorMsg = !this.state.first_try && !this.state.form.phone.valid;

        return (
            <div className={"backdrop " + this.state.animation_class} onClick={() => this.animateOut()}>
                <div className={"popup_wrapper sms-popup " + this.state.animation_class}
                     onClick={(e) => e.stopPropagation()}>
                    <div className="popup_content">
                        <div className="top-right">
                            <button className="x_close_icon"
                                    onClick={() => this.animateOut()}
                                    aria-label="סגור">
                                <img src={getMediaPath(x_close)} alt=""/>
                            </button>
                            <img className="image" src={getMediaPath(data.image)} alt=""/>
                        </div>
                        <div className="bottom-left">
                            {!appStatus &&
                                <div className="form">
                                    <div className="title">{data.title}</div>
                                    <div className="subtitle">{data.content}</div>
                                    <form onSubmit={this.handleSubmit}>
                                        <AnimatedInput type={'text'}
                                                       name={'phone'}
                                                       className={'phone-input'}
                                                       placeholder={data.placeHolder}
                                                       value={this.state.form.phone.val}
                                                       onChange={this.handleInput}
                                                       showError={showErrorMsg}
                                                       errorMessage={this.state.form.phone.errMsg}/>
                                        <button type="submit"
                                                className="green-button submit-button">{data.btnText}</button>
                                    </form>
                                    <Recaptcha isFunction={false} enterprise={true}/>
                                </div>
                            }
                            {appStatus &&
                                <div className="app-success">
                                    <span className="text">{data.after_content}</span>
                                    <button className="green-button close"
                                            onClick={() => this.animateOut()}>סגור
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.PopTrans,
        appDownStatus: store.data.AppDown,
        PopTrans: store.config.PopTrans,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        sendAppLinkSms: (payload) => dispatch(sendAppLinkSms(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, {pure: false})(AppPopup);
